import {
  nullableCreatedByUserUuid,
  timestamps,
  uuid,
} from '@snap-types/models/common';
import {
  LeadTimeStrategy,
  leadTimeStrategySchema,
} from '@snap-types/models/enums';
import { schema } from '@snap-types/schemas';
import {
  decimalIntegerDigitsLte,
  decimalScaleLte,
} from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

const d = schema.t.dec;

export const columns = {
  uuid,
  sortOrder: z.int().default(0),
  leadTimeType: leadTimeStrategySchema,
  priceStrategyConfigUuid: uuid,

  weeks: z.number().nullish(),
  nasPartWeeks: z.number().nullish(),
  defaultWeeks: z.number().nullish(),
  shiftHours: z.number().nullish(),
  bufferDays: z.number().nullish(),
  moveDayRatio: d.fromUnknown,

  ...nullableCreatedByUserUuid,
  ...timestamps,

  deletedAt: z.date().nullish(),
} as const;

export const constantValueColumns = z.object({
  leadTimeType: z.literal(LeadTimeStrategy.CONSTANT_VALUE),
  weeks: schema.t.num.fromString.pipe(schema.t.int.nonNegative),
});

export const planningLeadTimeColumns = z.object({
  leadTimeType: z.literal(LeadTimeStrategy.PLANNING_LEADTIME),
});

export const rafFixedMarketColumns = z.object({
  leadTimeType: z.literal(LeadTimeStrategy.RAF_FIXED_MARKET),
  nasPartWeeks: schema.t.num.fromString.pipe(schema.t.int.nonNegative),
  defaultWeeks: schema.t.num.fromString.pipe(schema.t.int.nonNegative),
});

export const quantityAwareColumns = z.object({
  leadTimeType: z.literal(LeadTimeStrategy.QUANTITY_AWARE),
  shiftHours: schema.t.num.fromString.pipe(schema.t.int.positive),
  bufferDays: schema.t.num.fromString.pipe(schema.t.int.nonNegative),
  // Scaled by the operation count to give the line's move days, so a site that
  // does not move between every operation can dial this below 1. Bounded to
  // what DECIMAL(3, 2) holds, so a value cannot be silently rounded on write.
  moveDayRatio: d.fromUnknown.check(
    d.checks.gt(0),
    decimalScaleLte(2),
    decimalIntegerDigitsLte(1),
  ),
});
